export default [
  {
    name: "gradientTexture",
    type: "texture",
    path: "textures/gradient.png",
  },
  {
    name: "voronoiTexture",
    type: "texture",
    path: "textures/voronoi.png",
  },
  {
    name: "fiveToneTexture",
    type: "texture",
    path: "textures/fiveTone.jpg",
  },

  {
    name: "elfCheeringVATTexture",
    type: "exrTexture",
    path: "textures/vat/elf/cheeringVAT.exr",
  },
  {
    name: "sittingVATTexture",
    type: "exrTexture",
    path: "textures/vat/elf/sittingVAT.exr",
  },
  {
    name: "enemyWalkVATTexture",
    type: "exrTexture",
    path: "textures/vat/enemy/walk.exr",
  },
  {
    name: "enemyDeathVATTexture",
    type: "exrTexture",
    path: "textures/vat/enemy/death.exr",
  },
  {
    name: "characterModel",
    type: "gltfModel",
    path: "models/character.glb",
  },
  {
    name: "campModel",
    type: "gltfModel",
    path: "models/camp.glb",
  },
  {
    name: "snowBallModel",
    type: "gltfModel",
    path: "models/snowBall.glb",
  },
  {
    name: "enemyModel",
    type: "gltfModel",
    path: "models/enemy.glb",
  },
  {
    name: "arenaColliderModel",
    type: "gltfModel",
    path: "models/arenaCollider.glb",
  },
  {
    name: "elfModel",
    type: "gltfModel",
    path: "models/elf.glb",
  },
  {
    name: "giftsModel",
    type: "gltfModel",
    path: "models/gifts.glb",
  },
];
